import React, {Fragment, useState} from 'react';
import {Button, Icon, Modal} from 'antd';
import Call from '../../../../hocs/call';
import {
  deleteFileMappingListFileMapping,
  deleteFileMappingListFileMappingAll,
  hideFileMappingListFileMapping,
  readFileMappingListFileMapping,
  readFileMappingListFileMappingCube,
  readFileMappingListFileMappings,
  showFileMappingListFileMapping
} from './actions';
import {MODAL_WIDTH_SM} from '../../../../styles/constants';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import FileMappingForm from '../../../../components/file-mapping-form';
import EnhancedModal from '../../../../components/enhanced-modal';
import {showFileMappingWizard} from "../wizard/actions";
import EnhancedTree from "../../../../components/enhanced-tree";
import {getNodes} from "../../../../utils/tree";
import {getLocalizedStr} from "../../../../middlewares/i18n/utils";
import {BUTTON_DELETE, BUTTON_DETAIL} from "../../../../styles/buttons";

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  fileMappingsTree: state.scenes.dataManager.fileMapping.components.list.fileMappingsTree,
  fileMappingId: state.scenes.dataManager.fileMapping.components.list.fileMappingId,
  fileMapping: state.scenes.dataManager.fileMapping.components.list.fileMapping,
  fileMappingCube: state.scenes.dataManager.fileMapping.components.list.fileMappingCube
});

const mapDispatchToProps = dispatch => ({
  onWizardShow: (cubeId, cubeCode) => dispatch(showFileMappingWizard(cubeId, cubeCode)),
  onFileMappingShow: fileMappingId => dispatch(showFileMappingListFileMapping(fileMappingId)),
  onFileMappingHide: () => dispatch(hideFileMappingListFileMapping()),
  onFileMappingDelete: fileMappingId => dispatch(deleteFileMappingListFileMapping(fileMappingId)),
  onFileMappingDeleteAll: fileMappingIds => dispatch(deleteFileMappingListFileMappingAll(fileMappingIds)),
  fetchFileMappings: () => dispatch(readFileMappingListFileMappings()),
  fetchFileMapping: fileMappingId => dispatch(readFileMappingListFileMapping(fileMappingId)),
  fetchFileMappingCube: cubeId => dispatch(readFileMappingListFileMappingCube(cubeId))
});

const FileMappingList = ({
                           t,
                           appLanguage,
                           dataLanguages,
                           fileMappingsTree,
                           fileMappingId,
                           fileMapping,
                           fileMappingCube,
                           onWizardShow,
                           onFileMappingShow,
                           onFileMappingHide,
                           onFileMappingDelete,
                           fetchFileMappings,
                           fetchFileMapping,
                           fetchFileMappingCube
                         }) => {

  const [selected, setSelected] = useState(null);

  return (
    <Fragment>
      <EnhancedModal
        visible={fileMappingId !== null}
        onCancel={onFileMappingHide}
        title={t('scenes.dataManager.fileMapping.list.fileMappingModal.title')}
        width={MODAL_WIDTH_SM}
        footer={<Button onClick={onFileMappingHide}>{t('commons.buttons.close.title')}</Button>}
        withDataLanguageSelector
      >
        <Call cb={fetchFileMapping} cbParam={fileMappingId}>
          <Call
            cb={fetchFileMappingCube}
            cbParam={fileMapping !== null && fileMapping.IDCube}
            disabled={fileMapping === null}
          >
            <FileMappingForm fileMapping={fileMapping} cube={fileMappingCube}/>
          </Call>
        </Call>
      </EnhancedModal>
      <Call cb={fetchFileMappings} disabled={fileMappingsTree !== null}>
        <EnhancedTree
          tree={fileMappingsTree}
          idKey="TreeID"
          nameKey="Name"
          childrenKey="children"
          catIdKey="TreeID"
          catNameKey="labels"
          getIsNameMultilanguage={node => !node.IDMapping}
          unselectableKeys={
            getNodes(fileMappingsTree, 'children', node => !node.IDMapping && !node.IDCube)
              .map(node => node.TreeID)
          }
          hiddenIdKeys={
            getNodes(fileMappingsTree, 'children', (({Code}) => !Code))
              .map(node => node.TreeID)
          }
          getIcon={({Code, IDMapping}) => {
            if (Code) {
              return (
                <IconFontCNIcon
                  theme="filled"
                  style={{color: "#37a0f4"}}
                  type="cube"
                />
              );
            } else if (IDMapping) {
              return (
                <Icon
                  theme="filled"
                  type="file-text"
                />
              );
            } else {
              return null;
            }
          }}
          getFilter={
            searchText =>
              ({labels, Code, Name}) => {
                const search = searchText.toLowerCase();
                return (Name && Name.toLowerCase()
                    .indexOf(search) >= 0) ||
                  (Code && Code.toLowerCase()
                    .indexOf(search) >= 0) ||
                  (labels && getLocalizedStr(labels, appLanguage, dataLanguages)
                    .toLowerCase()
                    .indexOf(search) >= 0);
              }
          }
          onSelect={selectedArr => {
            if (selectedArr && selectedArr[0]) {
              setSelected(selectedArr[0])
            } else {
              setSelected(null);
            }
          }}
          treeActions={[
            {
              title: t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),
              icon: 'sync',
              onClick: fetchFileMappings
            },
            {
              title: t('scenes.dataManager.fileMapping.wizardShowButton.label'),
              icon: 'plus',
              onClick: () => {
               if (selected && !selected.startsWith("Mapp_")) {
                 onWizardShow(
                   getNodes(
                     fileMappingsTree,
                     'children',
                       node => !!node.IDCube
                   ).find(({Code}) => Code === selected.replace("Mapp_", "")).IDCube,
                   selected
                 );
               } else {
                 onWizardShow();
               }
              }
            }
          ]}
          actions={
            (() => {
              if (selected && selected.startsWith("Mapp_")) {
                return [
                  {
                    ...BUTTON_DETAIL,
                    title: t('components.itemList.actions.view.title'),
                    onClick: () => onFileMappingShow(Number(selected.replace("Mapp_", "")))
                  },
                  {
                    ...BUTTON_DELETE,
                    title: t('components.itemList.actions.delete.title'),
                    onClick: () => Modal.confirm({
                      title: t('scenes.dataManager.fileMapping.list.deleteButton.confirm', {
                        id: (getNodes(fileMappingsTree, 'children', ({IDMapping}) => IDMapping === Number(selected.replace("Mapp_", ""))) || [])[0].Name
                      }),
                      onOk() {
                        setSelected(null);
                        onFileMappingDelete(Number(selected.replace("Mapp_", "")));
                      },
                      cancelText: t('commons.buttons.cancel.title')
                    })
                  }
                ];
              } else {
                return null;
              }
            })()
          }
        />
      </Call>
    </Fragment>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingList);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/list/index.jsx